import { BuilderFontCustomMetrics } from '../../builderFont/BuilderFontCustom';
import { Layer, LayerType } from './layer';

export enum TextFit {
    wordWrap = 'wordWrap' as any,
    shrinkToBounds = 'shrinkToBounds' as any,
    shrinkToBoundsV2 = 'shrinkToBoundsV2' as any,
}

export enum TextCase {
    lowercase = 'lowercase',
    uppercase = 'uppercase',
    default = '',
    // Other cases as required e.g. title case
}

export class TextLayer extends Layer {
    public text = 'New Text';

    public forceUserToProvideText = false;

    public lineHeight = 1.2;

    public fontSize = 120;

    public fontSizeUnit = 'pt' as const;

    public fontFamily = 'Open Sans';

    public textAlign: 'center' | 'justify' | 'left' | 'right' = 'center';

    public textVerticalAlign = 'top';

    public textBaseline = 'top';

    public direction = 'inherit';

    public textCase? = TextCase.default;

    public uppercase = false;

    public lowercase = false;

    public clip = false;

    public maxLength = 0;

    public textFit = TextFit.shrinkToBoundsV2;

    public letterSpacing = 0;

    public constructor(id: number) {
        super(id, LayerType.text);
        this.width = 300;
        this.height = 200;
    }
}

export function getFontMetricsForOpenSans(): BuilderFontCustomMetrics {
    return {
        ascent: 2189,
        bbox: {
            maxX: 2466,
            maxY: 2146,
            minX: -1126,
            minY: -555,
        },
        capHeight: 1462,
        descent: -600,
        italicAngle: 0,
        lineGap: 0,
        underlinePosition: -154,
        underlineThickness: 102,
        unitsPerEm: 2048,
        xHeight: 1096,
    };
}

export function getFontMetricsForArial(): BuilderFontCustomMetrics {
    return {
        ascent: 1836,
        bbox: {
            maxX: 2048,
            maxY: 1836,
            minX: -94,
            minY: -431,
        },
        capHeight: 1467,
        descent: -431,
        italicAngle: 0,
        lineGap: 0,
        underlinePosition: -277,
        underlineThickness: 130,
        unitsPerEm: 2048,
        xHeight: 1062,
    };
}

export const FALLBACK_FONT_METRICS: { [key: string]: BuilderFontCustomMetrics } = {
    'NotoSansJP-Regular': {
        ascent: 1160,
        bbox: {
            maxX: 2928,
            maxY: 1808,
            minX: -1002,
            minY: -1048,
        },
        capHeight: 733,
        descent: -320,
        italicAngle: 0,
        lineGap: 0,
        underlinePosition: -125,
        underlineThickness: 50,
        unitsPerEm: 1000,
        xHeight: 543,
    },
    'NotoSansKR-Regular': {
        ascent: 1160,
        bbox: {
            maxX: 2928,
            maxY: 1808,
            minX: -1002,
            minY: -1048,
        },
        capHeight: 733,
        descent: -320,
        italicAngle: 0,
        lineGap: 0,
        underlinePosition: -125,
        underlineThickness: 50,
        unitsPerEm: 1000,
        xHeight: 543,
    },
    'NotoSansSC-Regular': {
        ascent: 1160,
        bbox: {
            maxX: 2928,
            maxY: 1808,
            minX: -1002,
            minY: -1048,
        },
        capHeight: 733,
        descent: -320,
        italicAngle: 0,
        lineGap: 0,
        underlinePosition: -125,
        underlineThickness: 50,
        unitsPerEm: 1000,
        xHeight: 543,
    },
    'NotoSansTC-Regular': {
        ascent: 1160,
        bbox: {
            maxX: 2928,
            maxY: 1808,
            minX: -1002,
            minY: -1048,
        },
        capHeight: 733,
        descent: -320,
        italicAngle: 0,
        lineGap: 0,
        underlinePosition: -125,
        underlineThickness: 50,
        unitsPerEm: 1000,
        xHeight: 543,
    },
};

export function getFallbackFontMetrics(fontFamily: string): BuilderFontCustomMetrics | null {
    if (fontFamily in FALLBACK_FONT_METRICS) {
        return FALLBACK_FONT_METRICS[fontFamily];
    } else {
        return null;
    }
}

export function isTextLayer(layer: Layer): layer is TextLayer {
    return layer.type === LayerType.text;
}
